import { gatewayConfig } from '../gateway-config.js';
import { createGatewayHelpers, isLocalDev } from '../gateway-url.js';
// Build-time configuration sourced from VITE_* env vars. Each environment ships with its
// own `.env.production` consumed during `npm run build`. No runtime override layer —
// keeps the resolution rules simple: what `.env` says at build time is what the bundle uses.
//
// All API modules import { config, buildGatewayUrl, isLocalDev } from './config.js'.

export const config = Object.freeze({
  ...gatewayConfig,
  apiBase:          import.meta.env.VITE_API_URL                  || '/api',
  capabilityBase:   import.meta.env.VITE_CAPABILITY_URL           || '',
  // Sandbox 服务走独立域，不与 *.p 共享（见后端 configuration.ts 的说明）
  x402ChainId:      Number(import.meta.env.VITE_X402_CHAIN_ID     || 8453),
  x402Network:      import.meta.env.VITE_X402_NETWORK             || 'eip155:8453',
  x402Stablecoin:   import.meta.env.VITE_X402_STABLECOIN          || '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
  x402CheckoutPath: import.meta.env.VITE_X402_PAYMENT_CHECKOUT_URL|| '/payment/checkout',
  x402MinUsd:       Number(import.meta.env.VITE_MIN_PAYMENT_USD   || 0.01),
  x402MaxUsd:       Number(import.meta.env.VITE_MAX_PAYMENT_USD   || 100000),
});

export { isLocalDev };
export const { buildGatewayUrl, buildWsGatewayUrl, gatewayHost, gatewaySuffix } = createGatewayHelpers(config);
